import { rejectInvalidSyncKey } from 'serviceWorker/services/factories/invalidSyncKey';
import { LevelInDto } from 'shared/dtos/in/level';
import {
  defaultConfig,
  generateHeaders,
  parseResponse,
} from '../../helpers/httpRequests';
import {
  HeadersData,
  NormalizedEntityResponseData,
} from '../factories/types';
import { pull } from '../pull';

type ParseResponse = () => Promise<
  NormalizedEntityResponseData<LevelInDto>
>;

export const fetchLevels = (
  data: HeadersData,
  controller: AbortController
): Promise<NormalizedEntityResponseData<LevelInDto>> | undefined => {
  const { signal } = controller;
  if (shouldSkip(data, signal)) {
    return;
  }
  const builtUrl = `${data.api}/v2/project/${data.projectId}/level`;

  return pull(builtUrl, {
    ...defaultConfig,
    method: 'GET',
    headers: generateHeaders(data),
    signal,
  }).then((parseResponse as ParseResponse));
};

export const fetchUpdatedLevels = (
  data: HeadersData,
  syncKey: string,
  controller: AbortController
): Promise<NormalizedEntityResponseData<LevelInDto>> | undefined => {
  const { signal } = controller;
  if (!data.api || !data.projectId) {
    //not enough data, skip.
    return;
  }
  const builtUrl = `${data.api}/v2/project/${
    data.projectId
  }/level?syncKey=${encodeURIComponent(syncKey)}`;

  return pull(builtUrl, {
    ...defaultConfig,
    method: 'GET',
    headers: generateHeaders(data),
    signal,
  })
    .then((response: Response) => rejectInvalidSyncKey(response, 'levels'))
    .then((parseResponse as ParseResponse));
};

function shouldSkip(data: HeadersData, signal: AbortSignal): boolean {
  return !data.api || !data.projectId || signal.aborted;
}
